<template>
  <div v-if="content" class="minimalist-card"  :style="backgroundInlineStyle">
    <div class="img">
      <img :src="content.img" :alt="content.title">
      <h3 v-html="content.title"></h3>
    </div>
    <p v-html="content.text"></p>
    <btn-list :content="{btn: content.buttons}"></btn-list>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
    computed: {
      backgroundInlineStyle: function() {
        let background = ''
        if(this.content.background_image) {
          background += 'url('+this.content.background_image.filename +') '
        }
        if(this.content.background_color) {
          background += this.content.background_color.color
        }

        if(background === '') {
          return null
        } else {
          return 'background:'+background+';'
        }
      }
    },
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  };
</script>

<style lang="scss">
  .minimalist-card {
    .btn-list .list {
      width: 100%;
    }
  }

  .minimalist-card {
    background-size: cover;
    p {
      display: block;
      padding-top:1em;
      font-size:1.2rem;
      line-height:1.2;
    }

    .img {
      position: relative;

      img {
        width: 100%;
        height: auto;
        display: block;
      }

      h3 {
        color: #fff;
        position: absolute;
        bottom: 0;
        background-color: rgba(0, 0, 0, .6);
        width: 100%;
        padding: 0.5em;
        font-weight: bold;
        font-size: 1.4rem;
      }
    }
  }

  @media screen and (max-width:1000px) {
    .minimalist-card {
      max-width:500px;
      margin:auto;
    }
  }
</style>
